export default __webpack_public_path__ + "static/media/jwt.584a0b06.gif";